import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'
import Helmet from 'react-helmet';
import CookieBanner from 'react-cookie-banner';
import 'what-input';
import axios from 'axios';
import logoImg from './logo.png';
import QuestionList from './components/QuestionList/QuestionList';
import ResultModal from './components/ResultModal/ResultModal';
import Footer from './components/Footer/Footer';
import './App.css';
import './modifiers.css';
import {parseQueryString} from './helpers';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      winner: null,
      recommendations: null,
      status: "READY",
      aggregatedQuestions: [
      ],
      basket: [],
      totalQuestions: null,
      currentQuestion: 0,
      popQuestion: null,
      popAnswer: null,
      activeResult: null,
      showBasket: false,
      showBanner: true,
      utm: {
        source: "direct",
        medium: "fragrance_profiler",
        campaign: "",
        term: "",
        content: "",
      },
    }
    this.pushAnswer = this.pushAnswer.bind(this);
    this.getWeighting = this.getWeighting.bind(this);
    this.addToBasket = this.addToBasket.bind(this);
    this.removeFromBasket = this.removeFromBasket.bind(this);
    this.setTotalQuestions = this.setTotalQuestions.bind(this);
    this.setCurrentQuestion = this.setCurrentQuestion.bind(this);
    this.setActiveResult = this.setActiveResult.bind(this);
    this.toggleBasketVisibility = this.toggleBasketVisibility.bind(this);
    this.resetStatus = this.resetStatus.bind(this);
    this.changeQty = this.changeQty.bind(this);
  }

  resetStatus() {
    this.setState({ status: "READY" })
  }

  pushAnswer(answer, index) {
    let {aggregatedQuestions} = this.state;
    aggregatedQuestions[index] = answer;
    this.setState({ aggregatedQuestions: aggregatedQuestions });
  }

  addToBasket(item) {
    const {basket} = this.state;
    item.qty = 1;
    basket.push(item);
    this.setState({ basket: basket });
  }

  changeQty(item, amount) {
    let {basket} = this.state;
    const basketItem = basket.findIndex(b => item.fields.name === b.fields.name);
    if(basketItem === -1) { return null }
    basket[basketItem].qty = basket[basketItem].qty + amount;
    this.setState({ basket: basket });
  }

  toggleBasketVisibility() {
    this.setState({ showBasket: !this.state.showBasket });
  }

  removeFromBasket(item) {
    const {basket} = this.state;
    let newBasket = basket.filter(b => b.fields.name !== item.fields.name);
    this.setState({ basket: newBasket });
  }

  getWeighting(answers, type, price) {
    this.setState({ status: "LOADING" });
    let weightingAnswers = answers;
    weightingAnswers[3] = price;
    if(type === "Fragrances") { weightingAnswers[4] = "fragrance" }
    if(type === "Gift Sets") { weightingAnswers[4] = "giftSets" }
    if(type === "Home Fragrance") { weightingAnswers[4] = "homeFragrance" }
    if(type === "Bath and Body") { weightingAnswers[4] = "bathBody" }
    if(type === "Surprise Me") { weightingAnswers[4] = "surprise" }
    axios.get('https://us-central1-penfrag-ae15f.cloudfunctions.net/getGifts')
      .then( res => {
        const fragranceList = res.data.filter(function(n){ return n != null });
        let winningWeight = 0;
        let winner = {};
        // Loop through the fragrance list and assign weightings
        fragranceList.map( (profile, index) => {
          if(!profile && !profile.fields) {
            return null;
          }
          profile.weighting = 0;
          const {basket} = this.state;
          let basketIndex = -1;
          if(basket) {
            basketIndex = basket.findIndex(item => item.fields.name === profile.fields.name);
            if(basketIndex > -1) {
              profile.qty = basket[basketIndex].qty;
            }
          }
          // Loop through all qualities and check if they exist in weightingAnswers array
          Object.keys(profile.fields).map( (key) => {
            if(weightingAnswers.includes(key)) {
              // add trhe weighting if they do
              profile.weighting += Number(profile.fields[key]);
            }
            return profile.weighting;
          });

          if(profile.weighting > winningWeight) {
            winningWeight = profile.weighting;
            winner = profile;
          }
          return winner;
        });
        fragranceList.sort( (a, b) => {
          return b.weighting - a.weighting;
        })
        if(!winner.fields) {
          winner = fragranceList[0];
          fragranceList.shift();
        }
        this.trackEvent('Gift_Finder', `Recommended: ${winner.fields.name}`, 'Recommended', { "product": winner.fields.name });
        return this.setState({ recommendations: fragranceList, winner: winner, status: "SUCCESS" });
      })
  }

  setTotalQuestions(amount) {
    this.setState({ totalQuestions: amount });
  }

  setCurrentQuestion(q) {
    this.setState({ currentQuestion: q, popQuestion: null, popAnswer: null });
  }

  setActiveResult(result) {
    this.setState({ activeResult: result });
  }

  componentDidMount() {
    const query = window.location.search.substring(1);
    const params = parseQueryString(query);
    if(params.utm_source || params.utm_campaign || params.utm_medium || params.utm_term || params.utm_content) {
      const utm = {
        source: params.utm_source ? params.utm_source : "",
        campaign: params.utm_campaign ? params.utm_campaign : "",
        medium: params.utm_medium ? params.utm_medium : "",
        term: params.utm_term ? params.utm_term : "",
        content: params.utm_content ? params.utm_content : "",
      }
      this.setState({ utm });
    }
    ReactGA.initialize('UA-3013057-1', {
      debug: true,
      titleCase: false,
      gaOptions: {
        userId: 123
      }
    });
    const tagManagerArgs = {
      gtmId: 'DC-8515401'
    }
    TagManager.initialize(tagManagerArgs);
    window.onpopstate = (event) => {
      this.setState({ status: "READY" });
      this.setState({
        popQuestion: event.state.q,
        popAnswer: event.state.a,
      });
    }
  }

  trackEvent(category, action, mixPanelAction, mixPanelMeta) {
    if(!mixPanelAction) {
      mixPanelAction = action;
    }
    window.mixpanel.track(mixPanelAction, mixPanelMeta);
    ReactGA.event({
      category: category,
      action: action
    });
  }

  trackPage(page) {
    ReactGA.pageview(page);
  }

  render() {
    const {
      winner,
      recommendations,
      status,
      aggregatedQuestions,
      basket,
      popQuestion,
      popAnswer,
      activeResult,
      showBanner,
      showBasket
    } = this.state;
    let skuList = "";
    let qtyList = "";
    let basketCount = 0;
    let runningTotal = 0;
    basket.forEach( item => {
      skuList += item.fields.sku;
      skuList += "|";
      qtyList += `${item.qty}|`;
      basketCount += item.qty;
      if(item.fields.price) {
        runningTotal += item.qty * Number(item.fields.price.replace(/[^0-9\.-]+/g,""));
      }
    })
    return (
      <div className="App">
        <Helmet>
          { showBasket ?
            <body className="noScroll" />
          : null }
        </Helmet>
        <header className="App-header">
          <nav>
            <a href="https://penhaligons.com">
              <img src={logoImg} className="logo" alt="Penhaligon's Logo" />
            </a>
            <div className="basketButton" onClick={ () => this.setState({ showBasket: !this.state.showBasket })}>
              <img src={`${process.env.PUBLIC_URL}/basket.svg`} />
              <span>({basketCount})</span>
            </div>
            <div className={`basket ${ showBasket ? "basketShow" : "" }`}>
              <div className="basketClose" onClick={ () => this.setState({ showBasket: false }) }>&times;</div>
              { basket && basket.length ?
                <div className="selectedSamples">
                  { basket.map( item => (
                    <div className="selectedWrapper">
                      <div className="sample sampleAdded">
                        <img src={item.fields.prodImgUrl} alt={item.fields.name} />
                      </div>
                      <div className="sampleContent">
                        <h3>
                          {item.fields.name}
                        </h3>
                        <p>{item.fields.description}</p>
                        <p>
                          <span>{item.fields.price}</span>
                          <span className="qtyReadout">Quantity: {item.qty}</span>
                          <button
                            onClick={() => {
                              this.removeFromBasket(item);
                              this.trackEvent('Gift_Finder', `Removed from basket: ${item.fields.name}`)
                            }}
                            className="delete"
                          >
                            <b>&times;</b> <span>Remove</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  ))}
                  <div className="runningTotal">
                    <div className="priceReadout">
                      <h3>Subtotal</h3>
                      <p>£{runningTotal}</p>
                    </div>
                    <p className="small">Shipping will be calculated at the next stage.</p>
                  </div>
                </div>
              : null }
              <form
                action={`https://www.penhaligons.com/page/add_basket_api/?utm_source=${this.state.utm.source}&utm_campaign=${this.state.utm.campaign}&utm_medium=${this.state.utm.medium}&utm_term=${this.state.utm.term}&utm_content=${this.state.utm.content}`}
                method="post"
                id="checkoutForm"
                onSubmit={ 
                  (e) => {
                    e.preventDefault();
                    setTimeout( () => document.getElementById("checkoutForm").submit(), 100);
                  }
                }
              >
                { basket.length ?
                  <Fragment>
                    <input name="skulist" value={skuList.substr(0, skuList.length - 1)} type="hidden"/>
                    <input name="qtylist" value={qtyList.substr(0, qtyList.length - 1)} type="hidden"/>   
                  </Fragment>                       
                : null }
                { basket.length ?
                  <button className="button button--dark">
                    Checkout - £{runningTotal}
                  </button>
                :
                  <Fragment>
                    <button disabled className="button button--dark">
                      Checkout
                    </button>
                  </Fragment>
                }
              </form>
            </div>
          </nav>
        </header>
        { showBanner ?
          <div className="wrapper cookieWrapper">
            <CookieBanner>
              {(onAccept) => (
                <div className="cookieBanner">
                  <div className="cookieContent">
                    <p>We rely on cookies to remember your preferences and analyse our websites. <a href="https://www.penhaligons.com/cookie-policy/" target="_blank" rel="noopener noreferrer">View our cookie policy</a>.</p>
                  </div>
                  <div className="cookieButtons">
                    <button onClick={onAccept} className="button serif">Accept</button>
                  </div>
                </div>
              )}
            </CookieBanner>
          </div>
        : null }
        <main className="App-content">
          <QuestionList
            resetStatus={this.resetStatus}
            pushAnswer={this.pushAnswer}
            status={status}
            results={recommendations}
            winner={winner}
            getWeighting={this.getWeighting}
            aggregatedQuestions={aggregatedQuestions}
            addToBasket={this.addToBasket}
            removeFromBasket={this.removeFromBasket}
            basket={basket}
            setTotalQuestions={this.setTotalQuestions}
            setCurrentQuestion={this.setCurrentQuestion}
            popQuestion={popQuestion}
            popAnswer={popAnswer}
            setActiveResult={this.setActiveResult}
            trackPage={this.trackPage}
            trackEvent={this.trackEvent}
            changeQty={this.changeQty}
          />
        </main>
        { !showBasket ?
          <footer className="App-footer">
            <Footer
              basket={basket}
              removeFromBasket={this.removeFromBasket}
              showSteps={!this.winner ? true : false}
              currentQuestion={this.state.currentQuestion + 1}
              totalQuestions={this.state.totalQuestions}
              showBasket={this.state.showBasket}
              toggleBasketVisibility={this.toggleBasketVisibility}
              stepClick={ (step) => this.setState({ popQuestion: step }) }
              trackPage={this.trackPage}
              trackEvent={this.trackEvent}
              utm={this.state.utm}
            />
          </footer>
        : null }
        { activeResult ?
          <ResultModal
            {...activeResult}
            basket={basket}
            removeFromBasket={this.removeFromBasket}
            addToBasket={this.addToBasket}
            setActiveResult={this.setActiveResult}
            winner={winner}
            results={recommendations}
          />
        : null }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js